import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';

function MainLayout({centerVertically}) {

  const verticalStyles = centerVertically?"flex flex-col justify-center":"";

  return (
    <div className="App text-center min-h-screen relative max-w-4xl mx-auto flex flex-col px-2 max-[440px]:px-1 bg-nlg-bg">
      <Navbar />
      <main className={"App-content flex-grow pt-1 "+verticalStyles} >
        <Outlet />
      </main>
    </div>
  );
}

export default MainLayout;
